<template>
	<div class="row-project" :class="{ expanded: search.active_project.id == project.id }">
		<div class="row-project-main" @click="toggle_active()">
			<div class="result-title">
				<span class="file-type" :class="project_code">{{ project_code }}</span>
				<span class="title">{{ project.nom }}</span>
			</div>
			<div class="result-statut">
				<div class="statut-iter" :class="statut.slug"  v-for="statut in project.statut" :key="statut.slug">
					{{ statut.nom }}
				</div>
			</div>
			<div class="result-infos">
				<div class="result-info"><icon file="users" :size="16" />{{ contributors }}</div>
				<!-- <div class="result-info"><icon file="home" :size="16" />  {{ project.customer_company }}</div> -->
				<div class="result-info"><icon file="calendar" :size="16" /> Commandé le {{ project.dateCommande | moment }}</div>
			</div>
			<icon class="result-loader" file="loader" :size="24" />
		</div>
		<div class="row-project-content">
			
			<div class="studies">
				<router-link v-for="etude in project.etudes" :to="{ name: 'study', params: { id: etude.id } }" :key="etude.id" class="study" :class="{'active': deleting_study && etude.id === deleting_study.id}" @contextmenu.native.prevent="open_context_menu($event, etude)">
					<div class="bg"></div>
					<p class="name">{{ _.upperFirst(etude.etudeType.nom) }}</p>
					<p><span class="file-type" :class="etude.segment.code">{{ etude.segment.code }}</span></p>
					<div class="statut" :class="etude.statut.slug">{{ etude.statut.nom }}</div>
					<p class="date">{{ etude.dateCreation | moment }}</p>
					<p class="ref_evalis"> {{ etude.evalisReference }}</p>
					evalisReference
				</router-link>

				<vue-context ref="menu">
					<li>
						<a href="#" @click.prevent="confirm_delete_current_study_dialog = true">Supprimer l'étude</a>
					</li>
					<li>
						<a href="#" @click.prevent="confirm_duplicate_current_study_dialog = true">Dupliquer l'étude</a>
					</li>
				</vue-context>

				<q-dialog v-model="confirm_delete_current_study_dialog" persistent>
					<q-card>
						<q-card-section class="row items-center">
						<span class="q-ml-sm">Voulez-vous vraiment supprimer cette étude ?</span>
						</q-card-section>

						<q-card-actions align="right">
						<q-btn flat label="Non" color="primary" v-close-popup />
						<q-btn flat label="Oui" color="primary" v-close-popup @click="delete_current_study()" />
						</q-card-actions>
					</q-card>
				</q-dialog>
				<q-dialog v-model="confirm_duplicate_current_study_dialog" persistent>
					<q-card>
						<q-card-section class="row items-center">
						<span class="q-ml-sm">Voulez-vous vraiment dupliquer cette étude ?</span>
						</q-card-section>

						<q-card-actions align="right">
						<q-btn flat label="Non" color="primary" v-close-popup />
						<q-btn flat label="Oui" color="primary" v-close-popup @click="duplicate_current_study()" />
						</q-card-actions>
					</q-card>
				</q-dialog>
				<q-dialog v-model="inform_duplicate_current_study_in_progress" persistent>
					<q-card>
						<q-card-section class="row items-center card-duplication">
							<div class="loading-dup-study">
								<icon file="loader" :size="32" />
								<p>Duplication en cours...</p>
							</div>
						</q-card-section>
					</q-card>
				</q-dialog>
				
				<div class="study new" @click="show_new_study_window()">
					<div class="bg"></div>
					<p class="name">Ajouter une étude</p>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import VueContext from "vue-context";

moment.locale("fr");

export default {
	components: {
		VueContext
	},
	name: "row-project",
	data: function () {
		return {
			current_study: null,
			deleting_study: null,
			confirm_delete_current_study_dialog: false,
			confirm_duplicate_current_study_dialog: false,
			inform_duplicate_current_study_in_progress: false

		};
	},
	props: [ "project" ],
	computed: {
		...mapGetters([ "search", "active_study" ]),
		project_code () {
			if (this.project && this.project.segment && this.project.segment.code) {
				return this.project.segment.code;
			}
			return "";
		},
		contributors () {
			const contributors = _.map(this.project.contributeurs, "prenom");
			return contributors.join(", ");
		}
	},
	methods: {
		duplicate_current_study: async function (){
			try{
				this.inform_duplicate_current_study_in_progress = true;
				this.duplicate_study = this.current_study;
				await this.$store.dispatch("load_study", this.duplicate_study);
				const id = await this.$store.dispatch("duplicate_study",this.active_study);


				if(!id){
					throw new Error("creation request hasn\'t work");
				}
				await this.$store.dispatch("load_study", {id: id});

				await this.$router.push({ name: "study", params: { id: id } });
			}catch(e){
				console.error("error while duplicating study : " + e);

			}
		},
		toggle_active: function () {
			this.$store.dispatch("toggle_active_project", { project: this.project });
		},
		show_new_study_window: function () {
			this.$store.dispatch("set_new_study_for_active_project", { value: true });
			this.$store.dispatch("set_window", { name: "window-new-study" });
		},
		open_context_menu: function (event, study) {
			this.$refs.menu.open(event);
			this.current_study = study;
		},
		delete_current_study: function () {
			this.deleting_study = this.current_study;
			this.$store.dispatch("delete_study", { study_id: this.current_study.id, callback: () => {
				setTimeout(() => {
					this.$store.dispatch("search_projects");
					this.current_study = null;
				}, 300);
			}});
		}
	},
	filters: {
		moment: function (value) {
			return moment(value).format("ll");
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'
// @import '../../assets/css/grid'


.row-project
	border-bottom 1px solid #eee
	&:hover
		background-color lighten(red, 95%)
		.row-project-icon
			color red
			.file-type
				border-color red
				color red
		.row-project-main
			.result-title
				color red
	&.expanded
		background-color #f5f5f5
		background-color lighten(red, 95%)
		box-shadow inset 0 0 0 2px red
		.row-project-main
			.result-statut
				transform translateX(-2px)
		.row-project-content
			display block
	&.loading
		.row-project-main
			.result-loader
				display block
	.row-project-main
		padding 24px
		line-height 24px
		cursor pointer
		.result-title
			font-size 1.4rem
			font-weight 500
			.file-type
				float left
		.result-infos
			height 24px
			color #999
			.result-info
				display inline-block
				margin 0 24px 0 0
				> .icon
					float left
					margin 4px 8px 0 0
		.result-statut
			position absolute
			right 0
			top 24px
			height 24px
			padding 0 8px 0 6px
			font-weight 500
			line-height @height
			font-size 13px
			.statut-iter
				display inline-block
				height 24px
				padding 0 8px 0 6px
				font-weight 500
				line-height @height
				font-size 13px
				background-color blue
				transition transform 0.1s easeOutQuart
				color #fff
				&:before, &:after
					content ''
					position absolute
					left -8px
					width 0
					height 0
					border-style solid
				&:before
					top 0
					border-width 0 8px 16px 0
					border-color transparent blue transparent transparent
				&:after
					bottom 0
					border-width 0 0 16px 8px
					border-color transparent transparent blue transparent
				&.a-demarrer
					background-color red
					&:before
						border-color transparent red transparent transparent
					&:after
						border-color transparent transparent red transparent
				&.en-cours
					background-color blue
					&:before
						border-color transparent blue transparent transparent
					&:after
						border-color transparent transparent blue transparent
				&.publie
					background-color green
					&:before
						border-color transparent green transparent transparent
					&:after
						border-color transparent transparent green transparent

		.result-loader
			display none
			position absolute
			right 24px
			top 50%
			margin-top -12px
			animation rotate 1s infinite linear
	.row-project-content
		display none
		// min-height 500px
		// margin 16px 0 0 0
		padding 0 24px 24px 24px
		.studies
			display flex
			flex-wrap wrap
			padding-top 8px
			.study
				display inline-block
				height 140px
				width 96px
				margin 0 24px 16px 0
				padding 2px
				cursor pointer
				text-align center
				&:hover
					.bg
						box-shadow inset 0 0 0 2px red
						transform translateY(4px) translateX(-2px)
						&:before, &:after
							box-shadow inset 0 0 0 2px red
						&:before
							transform translateY(-2px) translateX(4px)
						&:after
							transform translateY(-4px) translateX(2px)
				&.new
					color dark
					border 2px dashed #888
					transform translateY(4px)
					&:hover
						border-color red
						color red
					.bg
						display none
						&:before, &:after
							display none
					.name
						padding 0
						height 100%
				&.active
					opacity 0.5
				.bg
					position absolute
					left 2px
					top 6px
					width 100%
					height 100%
					box-shadow inset 0 0 0 2px #888
					transition transform 0.25s easeOutQuart
					&:before, &:after
						content ''
						position absolute
						left 0px
						width 100%
						height 100%
						box-shadow inset 0 0 0 2px #888
						background-color #fff
						transition transform 0.25s easeOutQuart
					&:before
						left 1px
						bottom 3px
					&:after
						left -2px
						bottom 6px
				.name
					font-weight 500
					text-align center
					padding 42px 6px 4px 6px
					line-height 16px
					display flex
					align-items center
					justify-content center
				.statut
					position absolute
					left -4px
					top 8px
					// transform translateX(-50%)
					height 24px
					padding 0 8px
					margin 0 auto
					// border-radius radius
					background-color red
					white-space nowrap
					color #fff
					font-weight 500
					font-size 12px
					line-height @height
					&.publie
						background-color green
						box-shadow 1px 1px 0px darken(green, 10%)
						&:before
							border-color green transparent transparent transparent
						&:after
							border-color transparent transparent transparent green
							box-shadow 0 1px 0px darken(green, 10%)
					&.en-cours
						background-color blue
						box-shadow 1px 1px 0px darken(blue, 10%)
						&:before
							border-color blue transparent transparent transparent
						&:after
							border-color transparent transparent transparent blue
							box-shadow 0 1px 0px darken(blue, 10%)
					&:before, &:after
						content ''
						position absolute
						right -8px
						width 0
						height 0
						border-style solid
					&:before
						top 0
						border-width 16px 8px 0 0
					&:after
						bottom 0
						border-width 16px 0 0 8px
					.shadow
						position absolute
						left 0
						bottom -6px
						width 0
						height 0
						border-style solid
						border-width 0 6px 6px 0
						border-color transparent #666 transparent transparent
				.date
					position absolute
					right 4px
					bottom 6px
					padding 0 6px
					text-align center
					font-size 12px
					color #999
				.ref_evalis
					position absolute
					right 4px
					bottom 26px
					padding 0 6px
					text-align center
					font-size 12px
					color #999
					font-weight bold

.file-type
	display inline-block
	padding 0 8px
	margin 0 8px 0 0
	border-radius radius
	background-color #999
	font-size 1.2rem
	color #fff
	&.LLI
		background-color color_LLI
	&.LAC
		background-color color_LAC
	&.AUT
		background-color color_AUT
	&.GIE
		background-color color_GIE
	&.PSLA
		background-color color_PSLA
	&.LIB
		background-color color_LIB
	&.TER
		background-color color_TER
	&.RSS
		background-color color_RSS
	&.LLS
		background-color color_LLS
	&.RSE
		background-color color_RSE

.card-duplication
	padding 8px
	.loading-dup-study
		width 560px
		height 256px
		display flex
		flex-direction column
		align-items center
		justify-content center
		text-transform uppercase
		cursor progress
		.icon
			margin-bottom 16px
			animation rotate 1.5s infinite linear
</style>